import { FunctionComponent } from "react"
import { Typography } from "antd"
import { theme } from "src/global/ui/themes/theme"

interface PercentageDisplayProps {
  value: number
}

export const PercentageDisplay: FunctionComponent<PercentageDisplayProps> = ({ value }) => (
  <Typography.Text
    style={{
      fontSize: theme.typography.fontSize.hero,
      fontWeight: theme.typography.fontWeight.semibold,
      lineHeight: "38px",
    }}
  >
    {value}
    <Typography.Text
      style={{
        fontSize: theme.typography.fontSize.extraSmall,
        fontWeight: theme.typography.fontWeight.regular,
        lineHeight: theme.typography.lineHeight.small,
      }}
    >
      %
    </Typography.Text>
  </Typography.Text>
)
